import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

const GenderPopup = ({ open, onClose, onExplore, transformOrigin }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      transformOrigin={transformOrigin}
      header={
        <h2 className="text-2xl font-bold text-black text-center mb-6 font-playfair">
          Gender & Caregiving
        </h2>
      }
      footer={
        <div className="flex justify-center pt-6">
          <Button
            title="Explore"
            onClick={() => {
              if (onExplore) {
                onExplore();
              } else {
                onClose();
                navigate("/tabs?tab=gender");
              }
            }}
          />
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-base font-normal leading-loose text-black mb-4">
          Caregiving is deeply intertwined with gender inequality. Around the
          world, caregiving continues to be seen as women’s work due to existing
          gender norms, and a disproportionate amount of unpaid care work falls
          on women and girls. This inequality not only puts a high degree of
          load on women, but also exacerbates disparity when it comes to career
          and personal growth. This section brings to light global statistics
          highlighting this disparity, as well as country-specific
          initiatives/organizations working towards mitigating them.
        </p>

        <p className="text-base font-normal leading-loose text-black mb-3">
          The topics in this section include:
        </p>

        <ul className="space-y-1 text-base font-normal leading-loose text-black list-disc pl-6 mb-6">
          <li>An overview of gender inequality in caregiving</li>
          <li>Gender and social determinants of health</li>
          <li>
            How do countries in the Nooraverse (India, Bangladesh, Indonesia,
            Nepal) fare when it comes to gender equality in care?
          </li>
          <li>How can the gender inequality in care be addressed?</li>
          <li>
            Interesting interventions from around the world aiming to address
            gender inequality in caregiving
          </li>
          <li>Gender work within Noora Health</li>
        </ul>
      </div>
    </Modal>
  );
};

export default GenderPopup;
